import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { apiUrl, businessName } from '../../utils/consts';
import { formatMoney } from '../../utils/formatMoney';
import DeleteModal from '../DeleteModal/DeleteModal';
import { withRouter } from 'react-router';
import moment from 'moment';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedUserProducts(props) {

  const { token, userId } = props;

  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [productToDelete, setProductToDelete] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (productToDelete) setShowDeleteModal(true);
  }, [productToDelete]);

  const getData = async () => {
    setLoading(true);

    const productsProm = await fetch(`${apiUrl}/products/get/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        token,
        businessName
      })
    });

    const productsResp = await productsProm.json();

    if (productsResp.success) setProducts(productsResp.products);
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setProductToDelete(null);
    setShowDeleteModal(false);
  };

  const deleteProduct = async () => {

    if (productToDelete) {
      const deleteProm = await fetch(`${apiUrl}/products/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          id: productToDelete._id
        })
      });

      const deleteResp = await deleteProm.json();

      if (!deleteResp.success) alert('Ocurrió un error, inténtalo nuevamente.');
      else getData();

      closeDeleteModal();
    }
  };

  const deleteText = productToDelete ? `el producto ${productToDelete.name}` : '';

  if (loading) {
    return (
      <div className="user-products-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="user-products-component">
      <Container>
        <Row>
          <Col>
            <h3>Mis Productos</h3>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Fecha de creación</th>
                  <th>Precio</th>
                  <th style={{ textAlign: 'center' }}>Opciones</th>
                </tr>
              </thead>
              <tbody>
                {
                  products.map((product, index) =>
                    <tr key={product._id}>
                      <td>{index + 1}</td>
                      <td>{product.name}</td>
                      <td>{moment(product.dateCreated).format('YYYY-MM-DD')}</td>
                      <td>${formatMoney(product.hasDelivery ? product.price : product.price + product.deliveryPrice)}</td>
                      <td className="options">
                        <Button
                          className="edit-btn"
                          variant="info"
                          onClick={() => props.history.push(`/dashboard/productos/editar?id=${product._id}`)}
                        >
                          Editar
                        </Button>
                        <Button
                          className="delete-btn"
                          variant="danger"
                          onClick={() => setProductToDelete(product)}
                        >
                          Eliminar
                        </Button>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        text={deleteText}
        onClose={closeDeleteModal}
        onDelete={deleteProduct}
      />
    </div>
  );
}

const UserProducts = connect(select)(ConnectedUserProducts);

export default withRouter(UserProducts);
